import themeGet from '@styled-system/theme-get';
import { Link as GatsbyLink } from 'gatsby-plugin-react-intl';
import styled, { css } from 'styled-components';

import searchIcon from '../../../images/search-icon.svg';
import BurgerButton from '../../Custom/BurgerButton';
import Ctas from '../Ctas';
import Link from '../Link';

export const StyledHeader = styled.div`
  background-color: ${themeGet('colors.light-grey')};
  position: ${({ stickyHeader }) =>
    stickyHeader === true ? 'fixed' : 'relative'};
  margin-bottom: ${({ stickyHeader }) =>
    stickyHeader === true ? '0' : '-70px'};
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1000;
  display: block;

  ${({ bannerState }) => {
    if (bannerState === 'fixed') return fixedCss;
    else if (bannerState === 'notFixed') return notFixedCss;
    return null;
  }}
`;

const fixedCss = css`
  position: fixed;
  margin-bottom: 0;
`;

const notFixedCss = css`
  position: relative;
  margin-bottom: -70px;
`;

export const SkipToContentLink = styled.button`
  background: ${themeGet('colors.pc-red', '#E1251B')};
  color: ${themeGet('colors.white')};
  left: 0;
  padding: 1rem;
  /* border-radius: 0 0 10px 10px; */
  position: absolute;
  transform: translateY(-100%);
  transition: transform 0.3s;
  z-index: 1000;

  &:hover {
    color: ${themeGet('colors.white')};
    text-decoration: underline;
  }

  &:focus {
    transform: translateY(0%);
    left: 0;
  }
`;

export const TopNav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 70px;
`;

export const LogoLink = styled(GatsbyLink).attrs(() => ({
  rel: 'noopener noreferrer',
}))`
  display: flex;
  width: 100%;
  max-width: 126px;
  flex: 0 1 auto;
`;

export const Logo = styled.img`
  width: 100%;
  max-width: 120px;
  height: 100%;
  max-height: 48px;
`;

export const ApplicationWrapper = styled.div`
  .application-blade {
    display: none;
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      display: block;
    }
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  @media only screen and (max-width: 665px) {
    margin-left: 0.5rem;
  }
`;

export const ApplyNowLink = styled(Link)`
  margin: 0 0.5rem;

  &.btn-primary,
  &.btn-primary-inverse,
  &.btn-border {
    font-size: 0.875rem;

    & > svg {
      height: 12px;
      width: 12px;
    }
  }

  @media only screen and (max-width: 665px) {
    display: none !important;
  }
`;

export const MenuBtn = styled(BurgerButton)`
  /* added here due to global css file hiding spans for empty files */
  span {
    span {
      display: block;
    }
  }

  @media only screen and (max-width: 915px) and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
    flex: 1 0 87px;

    &:lang(fr) {
      flex: 1 0 109px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    display: none;
  }

  @media only screen and (max-width: 665px) {
    margin-left: 0.75rem;
  }
`;

export const StyledCtas = styled(Ctas)`
  margin: 0;

  &.btn-primary,
  &.btn-primary-inverse,
  &.btn-border {
    font-size: 0.875rem;
  }

  a {
    margin: 0 0.5rem;

    @media only screen and (max-width: 665px) {
      margin: 0 0.25rem;
    }
  }

  > div.legal-details {
    margin: 0;
    > button {
      place-content: center;
    }
  }
`;

export const NavigationBar = styled.div`
  display: flex;
  margin-left: 1.5rem;
`;

export const MenuFooter = styled.div`
  display: flex !important;
  position: absolute;
  bottom: 0;
  justify-content: center;
  box-shadow: -0.25rem 0 1.25rem 0 rgba(0, 0, 0, 0.1);
  padding: 1rem 2.75rem;
`;

export const CtaWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const SearchIcon = styled.button`
  background-image: url(${searchIcon});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  width: 35px;
  height: 35px;
`;

export const SearchDrawer = styled.div`
  z-index: 10;
  position: fixed;
  width: 100%;
  background: ${themeGet('colors.pc-dark-pink')};
  border-bottom: 1px solid ${themeGet('colors.surface-black')};
  top: 70px;
  left: 0;
  right: 0;
`;

export const SearchWrapper = styled.div`
  display: none;
  margin-left: 0;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    display: inline-flex;
  }
`;

export const StickyCtasContainer = styled.div`
  position: fixed;
  z-index: 999;
  bottom: 0;
  width: 100%;
  text-align: center;
  background-color: ${themeGet('colors.white')};
  box-shadow: 0px -10px 20px -10px rgba(102, 102, 102, 0.4);
  padding: 1rem 1rem 2rem 1rem;
  transition: all 0.5s;
  transition-timing-function: ease-in-out;

  &.hide {
    bottom: -100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: none;
  }
`;

export const StyledStickyCtas = styled(Ctas)`
  margin: 0;
  gap: 1rem;
  width: 100%;

  a {
    max-width: unset !important;
    width: 100% !important;
  }

  > div.legal-details {
    margin: 0;
    > button {
      place-content: center;
    }
  }
`;

export const HeaderCtas = styled.div`
  display: ${({ $footerSticky }) => ($footerSticky ? 'none' : 'flex')};
  flex-direction: row;
  align-items: center;
  > div:first-of-type {
    display: none;

    > div:first-of-type {
      &.application-blade {
        display: block;

        button {
          font-size: 0.875rem;
        }
      }
    }
  }

  ${Controls}.ContentfulCampaignPageLayout & {
    > div:first-of-type {
      display: ${({ $footerSticky }) => ($footerSticky ? 'none' : 'flex')};

      .application-blade {
        display: ${({ $footerSticky }) => ($footerSticky ? 'none' : 'block')};
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      > div:first-of-type {
        display: flex;

        .application-blade {
          display: block;
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    display: flex;

    > div:first-of-type {
      display: flex;
    }
  }
`;
